import { useDispatch, useSelector } from "react-redux";

// Actions
import { getDataLayerDetails } from "../../../actions/org/OrgDataLayerActions";
import {
  selectDataLayer,
  unselectDataLayer,
} from "../../../actions/map-view/DataLayerSelectionActions";

// Constants and Utils
import { DataLoading, HeaderWithActionButton } from "./PlanningUtils";

// Components
import CheckBox from "../../../components/check-box/CheckBox";
import Spinner from "../../../components/spinner/Spinner";

// Page Components
function DataLayersCheckboxList({
  cityId,
  dataLayers = [],
  dataLayersLoading,
}) {
  const dispatch = useDispatch();

  // Selector
  const dataLayerSelectedMap = useSelector(
    (state) => state.dataLayersSelection.isLayerSelected
  );
  const dataLayerDetailsLoadingMap = useSelector(
    (state) => state.orgDataLayers.dataLayerDetailsLoadingMap
  );

  // Loading
  if (dataLayersLoading) {
    return <DataLoading dataType="Data Layers" />;
  }

  // No Data Mag
  if (dataLayers.length === 0) {
    return (
      <p className="text-center font-italic text-muted">
        No Data Layers Available
      </p>
    );
  }

  // function
  function handleCheckboxChange(id, isLayerSelected) {
    if (!isLayerSelected) {
      dispatch(getDataLayerDetails(id));
    }

    // select and unSelect
    const dispatchFunction = isLayerSelected
      ? unselectDataLayer
      : selectDataLayer;

    dispatch(dispatchFunction(id));
  }

  return (
    <div className="px-3">
      {dataLayers.map((dataLayer) => {
        const { id, name, dataPointCountsByCity = {} } = dataLayer;

        const isLayerSelected = dataLayerSelectedMap[id] || false;
        const isSelectLoading = dataLayerDetailsLoadingMap[id] || false;
        const dataPointsCount = dataPointCountsByCity?.[cityId] || 0;

        return (
          <div className="d-flex justify-content-between mt-2" key={id}>
            <p className="mb-0" title={name}>
              {name}
            </p>
            <div className="d-flex align-items-center">
              {isSelectLoading && (
                <Spinner className="spinner-border-sm mr-2" />
              )}
              <span className="text-muted font-italic mt-n1">{`Total Points: ${dataPointsCount}`}</span>
              <CheckBox
                boxStyle="mb-0"
                inputBoxStyle="m-0"
                checkBoxKey={id}
                showLabel={false}
                checked={isLayerSelected}
                disabled={isSelectLoading}
                onChange={() => handleCheckboxChange(id, isLayerSelected)}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}

/**
 * Data Layers Tab
 */
export default function DataLayersTab({ cityId }) {
  // Data Layers
  const dataLayers = useSelector((state) => state.orgDataLayers.dataLayers);
  const dataLayersLoading = useSelector(
    (state) => state.orgDataLayers.dataLayersLoading
  );

  return (
    <>
      <HeaderWithActionButton title="Data Layers" showButton={false} />

      <DataLayersCheckboxList
        cityId={cityId}
        dataLayers={dataLayers}
        dataLayersLoading={dataLayersLoading}
      />
    </>
  );
}
